import {
  bodyLetterSpacing,
  fontFaceDeclarations,
  fontFaceProps,
  fontSizes,
  lineHeights
} from "./chunk-QSKJQZCB.esm.js";
import {
  colors_default
} from "./chunk-OZSFPHME.esm.js";
import {
  __commonJS,
  __toESM
} from "./chunk-Q6FVHJQC.esm.js";

// ../../node_modules/lodash.mergewith/index.js
var require_lodash = __commonJS({
  "../../node_modules/lodash.mergewith/index.js"(exports, module) {
    var LARGE_ARRAY_SIZE = 200;
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var HOT_COUNT = 800;
    var HOT_SPAN = 16;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var asyncTag = "[object AsyncFunction]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var nullTag = "[object Null]";
    var objectTag = "[object Object]";
    var proxyTag = "[object Proxy]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var undefinedTag = "[object Undefined]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function baseTimes(n, iteratee) {
      var index = -1, result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function overArg(func, transform2) {
      return function(arg) {
        return func(transform2(arg));
      };
    }
    var arrayProto = Array.prototype;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var coreJsData = root["__core-js_shared__"];
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    var nativeObjectToString = objectProto.toString;
    var objectCtorString = funcToString.call(Object);
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    var Buffer = moduleExports ? root.Buffer : void 0;
    var Symbol = root.Symbol;
    var Uint8Array = root.Uint8Array;
    var allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
    var getPrototype = overArg(Object.getPrototypeOf, Object);
    var objectCreate = Object.create;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var splice = arrayProto.splice;
    var symToStringTag = Symbol ? Symbol.toStringTag : void 0;
    var defineProperty = function() {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e) {
      }
    }();
    var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
    var nativeMax = Math.max;
    var nativeNow = Date.now;
    var Map2 = getNative(root, "Map");
    var nativeCreate = getNative(Object, "create");
    var baseCreate = function() {
      function object() {
      }
      return function(proto) {
        if (!isObject2(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = void 0;
        return result;
      };
    }();
    function Hash(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value) {
      var data = getMapData(this, key), size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    function stackDelete(key) {
      var data = this.__data__, result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    function stackGet(key) {
      return this.__data__.get(key);
    }
    function stackHas(key) {
      return this.__data__.has(key);
    }
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assignMergeValue(object, key, value) {
      if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    function baseAssignValue(object, key, value) {
      if (key == "__proto__" && defineProperty) {
        defineProperty(object, key, {
          "configurable": true,
          "enumerable": true,
          "value": value,
          "writable": true
        });
      } else {
        object[key] = value;
      }
    }
    var baseFor = createBaseFor();
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    function baseIsNative(value) {
      if (!isObject2(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    function baseKeysIn(object) {
      if (!isObject2(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object), result = [];
      for (var key in object) {
        if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack());
        if (isObject2(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        } else {
          var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
          if (newValue === void 0) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
      var isCommon = newValue === void 0;
      if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          } else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          } else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          } else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          } else {
            newValue = [];
          }
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          } else if (!isObject2(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        } else {
          isCommon = false;
        }
      }
      if (isCommon) {
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + "");
    }
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
      });
    };
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    function copyArray(source, array) {
      var index = -1, length = source.length;
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index = -1, length = props.length;
      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
        if (newValue === void 0) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? void 0 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    function initCloneObject(object) {
      return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    function isIterateeCall(value, index, object) {
      if (!isObject2(object)) {
        return false;
      }
      var type = typeof index;
      if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
        return eq(object[index], value);
      }
      return false;
    }
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    function overRest(func, start, transform2) {
      start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
      return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform2(array);
        return apply(func, this, otherArgs);
      };
    }
    function safeGet(object, key) {
      if (key === "constructor" && typeof object[key] === "function") {
        return;
      }
      if (key == "__proto__") {
        return;
      }
      return object[key];
    }
    var setToString = shortOut(baseSetToString);
    function shortOut(func) {
      var count = 0, lastCalled = 0;
      return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(void 0, arguments);
      };
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    var isArguments = baseIsArguments(function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    var isArray = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    var isBuffer = nativeIsBuffer || stubFalse;
    function isFunction(value) {
      if (!isObject2(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    function isObject2(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
      return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }
    var mergeWith5 = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });
    function constant(value) {
      return function() {
        return value;
      };
    }
    function identity(value) {
      return value;
    }
    function stubFalse() {
      return false;
    }
    module.exports = mergeWith5;
  }
});

// src/theme/index.ts
import { extendTheme } from "@chakra-ui/react";
import { mode as mode9 } from "@chakra-ui/theme-tools";

// src/theme/styles/navigation/Breadcrumb/Breadcrumb.ts
import { mode } from "@chakra-ui/theme-tools";
var Breadcrumb = {
  baseStyle: (props) => ({
    link: {
      fontSize: "sm",
      fontFamily: "suisseIntlRegular",
      color: mode("neutral.500", "neutral.300")(props),
      _hover: {
        color: mode("neutral.black", "neutral.200")(props),
        textDecoration: "none"
      }
    },
    separator: {
      color: mode("neutral.500", "neutral.300")(props),
      fontSize: "sm",
      mx: 1.5
    }
  })
};
var Breadcrumb_default = Breadcrumb;

// ../../node_modules/@chakra-ui/anatomy/dist/chunk-ZN6IUO2A.mjs
function anatomy(name, map = {}) {
  let called = false;
  function assert() {
    if (!called) {
      called = true;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function parts(...values) {
    assert();
    for (const part of values) {
      ;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function extend(...parts2) {
    for (const part of parts2) {
      if (part in map)
        continue;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function selectors() {
    const value = Object.fromEntries(
      Object.entries(map).map(([key, part]) => [key, part.selector])
    );
    return value;
  }
  function classnames() {
    const value = Object.fromEntries(
      Object.entries(map).map(([key, part]) => [key, part.className])
    );
    return value;
  }
  function toPart(part) {
    const el = ["container", "root"].includes(part != null ? part : "") ? [name] : [name, part];
    const attr = el.filter(Boolean).join("__");
    const className = `chakra-${attr}`;
    const partObj = {
      className,
      selector: `.${className}`,
      toString: () => part
    };
    return partObj;
  }
  const __type = {};
  return {
    parts,
    toPart,
    extend,
    selectors,
    classnames,
    get keys() {
      return Object.keys(map);
    },
    __type
  };
}

// ../../node_modules/@chakra-ui/anatomy/dist/chunk-HAKT6JCA.mjs
var accordionAnatomy = anatomy("accordion").parts("root", "container", "button", "panel").extend("icon");
var alertAnatomy = anatomy("alert").parts("title", "description", "container").extend("icon", "spinner");
var avatarAnatomy = anatomy("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var breadcrumbAnatomy = anatomy("breadcrumb").parts("link", "item", "container").extend("separator");
var buttonAnatomy = anatomy("button").parts();
var checkboxAnatomy = anatomy("checkbox").parts("control", "icon", "container").extend("label");
var circularProgressAnatomy = anatomy("progress").parts("track", "filledTrack").extend("label");
var drawerAnatomy = anatomy("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var editableAnatomy = anatomy("editable").parts(
  "preview",
  "input",
  "textarea"
);
var formAnatomy = anatomy("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
);
var formErrorAnatomy = anatomy("formError").parts("text", "icon");
var inputAnatomy = anatomy("input").parts("addon", "field", "element");
var listAnatomy = anatomy("list").parts("container", "item", "icon");
var menuAnatomy = anatomy("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider");
var modalAnatomy = anatomy("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var numberInputAnatomy = anatomy("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
var pinInputAnatomy = anatomy("pininput").parts("field");
var popoverAnatomy = anatomy("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var progressAnatomy = anatomy("progress").parts(
  "label",
  "filledTrack",
  "track"
);
var radioAnatomy = anatomy("radio").parts(
  "container",
  "control",
  "label"
);
var selectAnatomy = anatomy("select").parts("field", "icon");
var sliderAnatomy = anatomy("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
);
var statAnatomy = anatomy("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
);
var switchAnatomy = anatomy("switch").parts(
  "container",
  "track",
  "thumb"
);
var tableAnatomy = anatomy("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
);
var tabsAnatomy = anatomy("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
);
var tagAnatomy = anatomy("tag").parts(
  "container",
  "label",
  "closeButton"
);
var cardAnatomy = anatomy("card").parts(
  "container",
  "header",
  "body",
  "footer"
);

// ../../node_modules/@chakra-ui/shared-utils/dist/index.mjs
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// ../../node_modules/@chakra-ui/styled-system/dist/index.mjs
var import_lodash = __toESM(require_lodash(), 1);
var import_lodash2 = __toESM(require_lodash(), 1);
var import_lodash3 = __toESM(require_lodash(), 1);
var import_lodash4 = __toESM(require_lodash(), 1);
var isImportant = (value) => /!(important)?$/.test(value);
var withoutImportant = (value) => typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
var tokenToCSSVar = (scale, value) => (theme2) => {
  const valueStr = String(value);
  const important = isImportant(valueStr);
  const valueWithoutImportant = withoutImportant(valueStr);
  const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
  let transformed = isObject(theme2.__cssMap) && key in theme2.__cssMap ? theme2.__cssMap[key].varRef : value;
  transformed = withoutImportant(transformed);
  return important ? `${transformed} !important` : transformed;
};
function createTransform(options) {
  const { scale, transform: transform2, compose } = options;
  const fn = (value, theme2) => {
    var _a;
    const _value = tokenToCSSVar(scale, value)(theme2);
    let result = (_a = transform2 == null ? void 0 : transform2(_value, theme2)) != null ? _a : _value;
    if (compose) {
      result = compose(result, theme2);
    }
    return result;
  };
  return fn;
}
var pipe = (...fns) => (v) => fns.reduce((a, b) => b(a), v);
function toConfig(scale, transform2) {
  return (property) => {
    const result = { property, scale };
    result.transform = createTransform({
      scale,
      transform: transform2
    });
    return result;
  };
}
var getRtl = ({ rtl, ltr }) => (theme2) => theme2.direction === "rtl" ? rtl : ltr;
function logical(options) {
  const { property, scale, transform: transform2 } = options;
  return {
    scale,
    property: getRtl(property),
    transform: scale ? createTransform({
      scale,
      compose: transform2
    }) : transform2
  };
}
var transformTemplate = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function getTransformTemplate() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...transformTemplate
  ].join(" ");
}
function getTransformGpuTemplate() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...transformTemplate
  ].join(" ");
}
var filterTemplate = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
};
var backdropFilterTemplate = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function getRingTemplate(value) {
  return {
    "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
    "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
    "--chakra-ring-width": value,
    boxShadow: [
      `var(--chakra-ring-offset-shadow)`,
      `var(--chakra-ring-shadow)`,
      `var(--chakra-shadow, 0 0 #0000)`
    ].join(", ")
  };
}
var flexDirectionTemplate = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
};
var directionMap = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
};
var valueSet = new Set(Object.values(directionMap));
var globalSet = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]);
var trimSpace = (str) => str.trim();
function parseGradient(value, theme2) {
  if (value == null || globalSet.has(value))
    return value;
  const prevent = isCSSFunction(value) || globalSet.has(value);
  if (!prevent)
    return `url('${value}')`;
  const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
  const results = regex.exec(value);
  const type = results == null ? void 0 : results[1];
  const values = results == null ? void 0 : results[2];
  if (!type || !values)
    return value;
  const _type = type.includes("-gradient") ? type : `${type}-gradient`;
  const [maybeDirection, ...stops] = values.split(",").map(trimSpace).filter(Boolean);
  if ((stops == null ? void 0 : stops.length) === 0)
    return value;
  const direction = maybeDirection in directionMap ? directionMap[maybeDirection] : maybeDirection;
  stops.unshift(direction);
  const _values = stops.map((stop) => {
    if (valueSet.has(stop))
      return stop;
    const firstStop = stop.indexOf(" ");
    const [_color, _stop] = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop];
    const _stopOrFunc = isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
    const key = `colors.${_color}`;
    const color2 = key in theme2.__cssMap ? theme2.__cssMap[key].varRef : _color;
    return _stopOrFunc ? [
      color2,
      ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc]
    ].join(" ") : color2;
  });
  return `${_type}(${_values.join(", ")})`;
}
var isCSSFunction = (value) => {
  return typeof value === "string" && value.includes("(") && value.includes(")");
};
var gradientTransform = (value, theme2) => parseGradient(value, theme2 != null ? theme2 : {});
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}
var analyzeCSSValue = (value) => {
  const num = parseFloat(value.toString());
  const unit = value.toString().replace(String(num), "");
  return { unitless: !unit, value: num, unit };
};
var wrap = (str) => (value) => `${str}(${value})`;
var transformFunctions = {
  filter(value) {
    return value !== "auto" ? value : filterTemplate;
  },
  backdropFilter(value) {
    return value !== "auto" ? value : backdropFilterTemplate;
  },
  ring(value) {
    return getRingTemplate(transformFunctions.px(value));
  },
  bgClip(value) {
    return value === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: value };
  },
  transform(value) {
    if (value === "auto")
      return getTransformTemplate();
    if (value === "auto-gpu")
      return getTransformGpuTemplate();
    return value;
  },
  vh(value) {
    return value === "$100vh" ? "var(--chakra-vh)" : value;
  },
  px(value) {
    if (value == null)
      return value;
    const { unitless } = analyzeCSSValue(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
  },
  fraction(value) {
    return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
  },
  float(value, theme2) {
    const map = { left: "right", right: "left" };
    return theme2.direction === "rtl" ? map[value] : value;
  },
  degree(value) {
    if (isCssVar(value) || value == null)
      return value;
    const unitless = typeof value === "string" && !value.endsWith("deg");
    return typeof value === "number" || unitless ? `${value}deg` : value;
  },
  gradient: gradientTransform,
  blur: wrap("blur"),
  opacity: wrap("opacity"),
  brightness: wrap("brightness"),
  contrast: wrap("contrast"),
  dropShadow: wrap("drop-shadow"),
  grayscale: wrap("grayscale"),
  hueRotate: wrap("hue-rotate"),
  invert: wrap("invert"),
  saturate: wrap("saturate"),
  sepia: wrap("sepia"),
  bgImage(value) {
    if (value == null)
      return value;
    const prevent = isCSSFunction(value) || globalSet.has(value);
    return !prevent ? `url(${value})` : value;
  },
  outline(value) {
    const isNoneOrZero = String(value) === "0" || String(value) === "none";
    return value !== null && isNoneOrZero ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: value };
  },
  flexDirection(value) {
    var _a;
    const { space: space2, divide: divide2 } = (_a = flexDirectionTemplate[value]) != null ? _a : {};
    const result = { flexDirection: value };
    if (space2)
      result[space2] = 1;
    if (divide2)
      result[divide2] = 1;
    return result;
  }
};
var t = {
  borderWidths: toConfig("borderWidths"),
  borderStyles: toConfig("borderStyles"),
  colors: toConfig("colors"),
  borders: toConfig("borders"),
  gradients: toConfig("gradients", transformFunctions.gradient),
  radii: toConfig("radii", transformFunctions.px),
  space: toConfig("space", pipe(transformFunctions.vh, transformFunctions.px)),
  spaceT: toConfig("space", pipe(transformFunctions.vh, transformFunctions.px)),
  degreeT(property) {
    return { property, transform: transformFunctions.degree };
  },
  prop(property, scale, transform2) {
    return {
      property,
      scale,
      ...scale && {
        transform: createTransform({ scale, transform: transform2 })
      }
    };
  },
  propT(property, transform2) {
    return { property, transform: transform2 };
  },
  sizes: toConfig("sizes", pipe(transformFunctions.vh, transformFunctions.px)),
  sizesT: toConfig("sizes", pipe(transformFunctions.vh, transformFunctions.fraction)),
  shadows: toConfig("shadows"),
  logical,
  blur: toConfig("blur", transformFunctions.blur)
};
var background = {
  background: t.colors("background"),
  backgroundColor: t.colors("backgroundColor"),
  backgroundImage: t.gradients("backgroundImage"),
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true,
  backgroundClip: { transform: transformFunctions.bgClip },
  bgSize: t.prop("backgroundSize"),
  bgPosition: t.prop("backgroundPosition"),
  bg: t.colors("background"),
  bgColor: t.colors("backgroundColor"),
  bgPos: t.prop("backgroundPosition"),
  bgRepeat: t.prop("backgroundRepeat"),
  bgAttachment: t.prop("backgroundAttachment"),
  bgGradient: t.gradients("backgroundImage"),
  bgClip: { transform: transformFunctions.bgClip }
};
Object.assign(background, {
  bgImage: background.backgroundImage,
  bgImg: background.backgroundImage
});
var border = {
  border: t.borders("border"),
  borderWidth: t.borderWidths("borderWidth"),
  borderStyle: t.borderStyles("borderStyle"),
  borderColor: t.colors("borderColor"),
  borderRadius: t.radii("borderRadius"),
  borderTop: t.borders("borderTop"),
  borderBlockStart: t.borders("borderBlockStart"),
  borderTopLeftRadius: t.radii("borderTopLeftRadius"),
  borderStartStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: t.radii("borderTopRightRadius"),
  borderStartEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: t.borders("borderRight"),
  borderInlineEnd: t.borders("borderInlineEnd"),
  borderBottom: t.borders("borderBottom"),
  borderBlockEnd: t.borders("borderBlockEnd"),
  borderBottomLeftRadius: t.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: t.radii("borderBottomRightRadius"),
  borderLeft: t.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: t.borders(["borderLeft", "borderRight"]),
  borderInline: t.borders("borderInline"),
  borderY: t.borders(["borderTop", "borderBottom"]),
  borderBlock: t.borders("borderBlock"),
  borderTopWidth: t.borderWidths("borderTopWidth"),
  borderBlockStartWidth: t.borderWidths("borderBlockStartWidth"),
  borderTopColor: t.colors("borderTopColor"),
  borderBlockStartColor: t.colors("borderBlockStartColor"),
  borderTopStyle: t.borderStyles("borderTopStyle"),
  borderBlockStartStyle: t.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: t.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: t.borderWidths("borderBlockEndWidth"),
  borderBottomColor: t.colors("borderBottomColor"),
  borderBlockEndColor: t.colors("borderBlockEndColor"),
  borderBottomStyle: t.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: t.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: t.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: t.borderWidths("borderInlineStartWidth"),
  borderLeftColor: t.colors("borderLeftColor"),
  borderInlineStartColor: t.colors("borderInlineStartColor"),
  borderLeftStyle: t.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: t.borderStyles("borderInlineStartStyle"),
  borderRightWidth: t.borderWidths("borderRightWidth"),
  borderInlineEndWidth: t.borderWidths("borderInlineEndWidth"),
  borderRightColor: t.colors("borderRightColor"),
  borderInlineEndColor: t.colors("borderInlineEndColor"),
  borderRightStyle: t.borderStyles("borderRightStyle"),
  borderInlineEndStyle: t.borderStyles("borderInlineEndStyle"),
  borderTopRadius: t.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: t.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: t.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: t.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(border, {
  rounded: border.borderRadius,
  roundedTop: border.borderTopRadius,
  roundedTopLeft: border.borderTopLeftRadius,
  roundedTopRight: border.borderTopRightRadius,
  roundedTopStart: border.borderStartStartRadius,
  roundedTopEnd: border.borderStartEndRadius,
  roundedBottom: border.borderBottomRadius,
  roundedBottomLeft: border.borderBottomLeftRadius,
  roundedBottomRight: border.borderBottomRightRadius,
  roundedBottomStart: border.borderEndStartRadius,
  roundedBottomEnd: border.borderEndEndRadius,
  roundedLeft: border.borderLeftRadius,
  roundedRight: border.borderRightRadius,
  roundedStart: border.borderInlineStartRadius,
  roundedEnd: border.borderInlineEndRadius,
  borderStart: border.borderInlineStart,
  borderEnd: border.borderInlineEnd,
  borderTopStartRadius: border.borderStartStartRadius,
  borderTopEndRadius: border.borderStartEndRadius,
  borderBottomStartRadius: border.borderEndStartRadius,
  borderBottomEndRadius: border.borderEndEndRadius,
  borderStartRadius: border.borderInlineStartRadius,
  borderEndRadius: border.borderInlineEndRadius,
  borderStartWidth: border.borderInlineStartWidth,
  borderEndWidth: border.borderInlineEndWidth,
  borderStartColor: border.borderInlineStartColor,
  borderEndColor: border.borderInlineEndColor,
  borderStartStyle: border.borderInlineStartStyle,
  borderEndStyle: border.borderInlineEndStyle
});
var color = {
  color: t.colors("color"),
  textColor: t.colors("color"),
  fill: t.colors("fill"),
  stroke: t.colors("stroke")
};
var effect = {
  boxShadow: t.shadows("boxShadow"),
  mixBlendMode: true,
  blendMode: t.prop("mixBlendMode"),
  backgroundBlendMode: true,
  bgBlendMode: t.prop("backgroundBlendMode"),
  opacity: true
};
Object.assign(effect, {
  shadow: effect.boxShadow
});
var filter = {
  filter: { transform: transformFunctions.filter },
  blur: t.blur("--chakra-blur"),
  brightness: t.propT("--chakra-brightness", transformFunctions.brightness),
  contrast: t.propT("--chakra-contrast", transformFunctions.contrast),
  hueRotate: t.degreeT("--chakra-hue-rotate"),
  invert: t.propT("--chakra-invert", transformFunctions.invert),
  saturate: t.propT("--chakra-saturate", transformFunctions.saturate),
  dropShadow: t.propT("--chakra-drop-shadow", transformFunctions.dropShadow),
  backdropFilter: { transform: transformFunctions.backdropFilter },
  backdropBlur: t.blur("--chakra-backdrop-blur"),
  backdropBrightness: t.propT(
    "--chakra-backdrop-brightness",
    transformFunctions.brightness
  ),
  backdropContrast: t.propT("--chakra-backdrop-contrast", transformFunctions.contrast),
  backdropHueRotate: t.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: t.propT("--chakra-backdrop-invert", transformFunctions.invert),
  backdropSaturate: t.propT("--chakra-backdrop-saturate", transformFunctions.saturate)
};
var flexbox = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: { transform: transformFunctions.flexDirection },
  flex: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: t.sizes("flexBasis"),
  justifySelf: true,
  alignSelf: true,
  order: true,
  placeItems: true,
  placeContent: true,
  placeSelf: true,
  gap: t.space("gap"),
  rowGap: t.space("rowGap"),
  columnGap: t.space("columnGap")
};
Object.assign(flexbox, {
  flexDir: flexbox.flexDirection
});
var grid = {
  gridGap: t.space("gridGap"),
  gridColumnGap: t.space("gridColumnGap"),
  gridRowGap: t.space("gridRowGap"),
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridAutoRows: true,
  gridTemplate: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var interactivity = {
  appearance: true,
  cursor: true,
  resize: true,
  userSelect: true,
  pointerEvents: true,
  outline: { transform: transformFunctions.outline },
  outlineOffset: true,
  outlineColor: t.colors("outlineColor")
};
var layout = {
  width: t.sizesT("width"),
  inlineSize: t.sizesT("inlineSize"),
  height: t.sizes("height"),
  blockSize: t.sizes("blockSize"),
  boxSize: t.sizes(["width", "height"]),
  minWidth: t.sizes("minWidth"),
  minInlineSize: t.sizes("minInlineSize"),
  minHeight: t.sizes("minHeight"),
  minBlockSize: t.sizes("minBlockSize"),
  maxWidth: t.sizes("maxWidth"),
  maxInlineSize: t.sizes("maxInlineSize"),
  maxHeight: t.sizes("maxHeight"),
  maxBlockSize: t.sizes("maxBlockSize"),
  overflow: true,
  overflowX: true,
  overflowY: true,
  overscrollBehavior: true,
  overscrollBehaviorX: true,
  overscrollBehaviorY: true,
  display: true,
  aspectRatio: true,
  hideFrom: {
    scale: "breakpoints",
    transform: (value, theme2) => {
      var _a, _b, _c;
      const breakpoint = (_c = (_b = (_a = theme2.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b.minW) != null ? _c : value;
      const mq = `@media screen and (min-width: ${breakpoint})`;
      return { [mq]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (value, theme2) => {
      var _a, _b, _c;
      const breakpoint = (_c = (_b = (_a = theme2.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b._minW) != null ? _c : value;
      const mq = `@media screen and (max-width: ${breakpoint})`;
      return { [mq]: { display: "none" } };
    }
  },
  verticalAlign: true,
  boxSizing: true,
  boxDecorationBreak: true,
  float: t.propT("float", transformFunctions.float),
  objectFit: true,
  objectPosition: true,
  visibility: true,
  isolation: true
};
Object.assign(layout, {
  w: layout.width,
  h: layout.height,
  minW: layout.minWidth,
  maxW: layout.maxWidth,
  minH: layout.minHeight,
  maxH: layout.maxHeight,
  overscroll: layout.overscrollBehavior,
  overscrollX: layout.overscrollBehaviorX,
  overscrollY: layout.overscrollBehaviorY
});
var list = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: t.prop("listStylePosition"),
  listStyleImage: true,
  listStyleImg: t.prop("listStyleImage")
};
function get(obj, path, fallback, index) {
  const key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj)
      break;
    obj = obj[key[index]];
  }
  return obj === void 0 ? fallback : obj;
}
var memoize = (fn) => {
  const cache = /* @__PURE__ */ new WeakMap();
  const memoizedFn = (obj, path, fallback, index) => {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, /* @__PURE__ */ new Map());
    }
    const map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    const value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet = memoize(get);
var srOnly = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
var srFocusable = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
};
var getWithPriority = (theme2, key, styles) => {
  const result = {};
  const obj = memoizedGet(theme2, key, {});
  for (const prop in obj) {
    const isInStyles = prop in styles && styles[prop] != null;
    if (!isInStyles)
      result[prop] = obj[prop];
  }
  return result;
};
var others = {
  srOnly: {
    transform(value) {
      if (value === true)
        return srOnly;
      if (value === "focusable")
        return srFocusable;
      return {};
    }
  },
  layerStyle: {
    processResult: true,
    transform: (value, theme2, styles) => getWithPriority(theme2, `layerStyles.${value}`, styles)
  },
  textStyle: {
    processResult: true,
    transform: (value, theme2, styles) => getWithPriority(theme2, `textStyles.${value}`, styles)
  },
  apply: {
    processResult: true,
    transform: (value, theme2, styles) => getWithPriority(theme2, value, styles)
  }
};
var position = {
  position: true,
  pos: t.prop("position"),
  zIndex: t.prop("zIndex", "zIndices"),
  inset: t.spaceT("inset"),
  insetX: t.spaceT(["left", "right"]),
  insetInline: t.spaceT("insetInline"),
  insetY: t.spaceT(["top", "bottom"]),
  insetBlock: t.spaceT("insetBlock"),
  top: t.spaceT("top"),
  insetBlockStart: t.spaceT("insetBlockStart"),
  bottom: t.spaceT("bottom"),
  insetBlockEnd: t.spaceT("insetBlockEnd"),
  left: t.spaceT("left"),
  insetInlineStart: t.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: t.spaceT("right"),
  insetInlineEnd: t.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(position, {
  insetStart: position.insetInlineStart,
  insetEnd: position.insetInlineEnd
});
var ring = {
  ring: { transform: transformFunctions.ring },
  ringColor: t.colors("--chakra-ring-color"),
  ringOffset: t.prop("--chakra-ring-offset-width"),
  ringOffsetColor: t.colors("--chakra-ring-offset-color"),
  ringInset: t.prop("--chakra-ring-inset")
};
var space = {
  margin: t.spaceT("margin"),
  marginTop: t.spaceT("marginTop"),
  marginBlockStart: t.spaceT("marginBlockStart"),
  marginRight: t.spaceT("marginRight"),
  marginInlineEnd: t.spaceT("marginInlineEnd"),
  marginBottom: t.spaceT("marginBottom"),
  marginBlockEnd: t.spaceT("marginBlockEnd"),
  marginLeft: t.spaceT("marginLeft"),
  marginInlineStart: t.spaceT("marginInlineStart"),
  marginX: t.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: t.spaceT("marginInline"),
  marginY: t.spaceT(["marginTop", "marginBottom"]),
  marginBlock: t.spaceT("marginBlock"),
  padding: t.space("padding"),
  paddingTop: t.space("paddingTop"),
  paddingBlockStart: t.space("paddingBlockStart"),
  paddingRight: t.space("paddingRight"),
  paddingBottom: t.space("paddingBottom"),
  paddingBlockEnd: t.space("paddingBlockEnd"),
  paddingLeft: t.space("paddingLeft"),
  paddingInlineStart: t.space("paddingInlineStart"),
  paddingInlineEnd: t.space("paddingInlineEnd"),
  paddingX: t.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: t.space("paddingInline"),
  paddingY: t.space(["paddingTop", "paddingBottom"]),
  paddingBlock: t.space("paddingBlock")
};
Object.assign(space, {
  m: space.margin,
  mt: space.marginTop,
  mr: space.marginRight,
  me: space.marginInlineEnd,
  marginEnd: space.marginInlineEnd,
  mb: space.marginBottom,
  ml: space.marginLeft,
  ms: space.marginInlineStart,
  marginStart: space.marginInlineStart,
  mx: space.marginX,
  my: space.marginY,
  p: space.padding,
  pt: space.paddingTop,
  py: space.paddingY,
  px: space.paddingX,
  pb: space.paddingBottom,
  pl: space.paddingLeft,
  ps: space.paddingInlineStart,
  paddingStart: space.paddingInlineStart,
  pr: space.paddingRight,
  pe: space.paddingInlineEnd,
  paddingEnd: space.paddingInlineEnd
});
var textDecoration = {
  textDecorationColor: t.colors("textDecorationColor"),
  textDecoration: true,
  textDecor: { property: "textDecoration" },
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationThickness: true,
  textUnderlineOffset: true,
  textShadow: t.shadows("textShadow")
};
var transform = {
  clipPath: true,
  transform: t.propT("transform", transformFunctions.transform),
  transformOrigin: true,
  translateX: t.spaceT("--chakra-translate-x"),
  translateY: t.spaceT("--chakra-translate-y"),
  skewX: t.degreeT("--chakra-skew-x"),
  skewY: t.degreeT("--chakra-skew-y"),
  scaleX: t.prop("--chakra-scale-x"),
  scaleY: t.prop("--chakra-scale-y"),
  scale: t.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: t.degreeT("--chakra-rotate")
};
var transition = {
  transition: true,
  transitionDelay: true,
  animation: true,
  willChange: true,
  transitionDuration: t.prop("transitionDuration", "transition.duration"),
  transitionProperty: t.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: t.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
};
var typography = {
  fontFamily: t.prop("fontFamily", "fonts"),
  fontSize: t.prop("fontSize", "fontSizes", transformFunctions.px),
  fontWeight: t.prop("fontWeight", "fontWeights"),
  lineHeight: t.prop("lineHeight", "lineHeights"),
  letterSpacing: t.prop("letterSpacing", "letterSpacings"),
  textAlign: true,
  fontStyle: true,
  textIndent: true,
  wordBreak: true,
  overflowWrap: true,
  textOverflow: true,
  textTransform: true,
  whiteSpace: true,
  isTruncated: {
    transform(value) {
      if (value === true) {
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
      }
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
};
var scroll = {
  scrollBehavior: true,
  scrollSnapAlign: true,
  scrollSnapStop: true,
  scrollSnapType: true,
  scrollMargin: t.spaceT("scrollMargin"),
  scrollMarginTop: t.spaceT("scrollMarginTop"),
  scrollMarginBottom: t.spaceT("scrollMarginBottom"),
  scrollMarginLeft: t.spaceT("scrollMarginLeft"),
  scrollMarginRight: t.spaceT("scrollMarginRight"),
  scrollMarginX: t.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: t.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  scrollPadding: t.spaceT("scrollPadding"),
  scrollPaddingTop: t.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: t.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: t.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: t.spaceT("scrollPaddingRight"),
  scrollPaddingX: t.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: t.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function resolveReference(operand) {
  if (isObject(operand) && operand.reference) {
    return operand.reference;
  }
  return String(operand);
}
var toExpression = (operator, ...operands) => operands.map(resolveReference).join(` ${operator} `).replace(/calc/g, "");
var add = (...operands) => `calc(${toExpression("+", ...operands)})`;
var subtract = (...operands) => `calc(${toExpression("-", ...operands)})`;
var multiply = (...operands) => `calc(${toExpression("*", ...operands)})`;
var divide = (...operands) => `calc(${toExpression("/", ...operands)})`;
var negate = (x) => {
  const value = resolveReference(x);
  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
  }
  return multiply(value, -1);
};
var calc = Object.assign(
  (x) => ({
    add: (...operands) => calc(add(x, ...operands)),
    subtract: (...operands) => calc(subtract(x, ...operands)),
    multiply: (...operands) => calc(multiply(x, ...operands)),
    divide: (...operands) => calc(divide(x, ...operands)),
    negate: () => calc(negate(x)),
    toString: () => x.toString()
  }),
  {
    add,
    subtract,
    multiply,
    divide,
    negate
  }
);
var state = {
  hover: (str, post) => `${str}:hover ${post}, ${str}[data-hover] ${post}`,
  focus: (str, post) => `${str}:focus ${post}, ${str}[data-focus] ${post}`,
  focusVisible: (str, post) => `${str}:focus-visible ${post}`,
  focusWithin: (str, post) => `${str}:focus-within ${post}`,
  active: (str, post) => `${str}:active ${post}, ${str}[data-active] ${post}`,
  disabled: (str, post) => `${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
  invalid: (str, post) => `${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
  checked: (str, post) => `${str}:checked ${post}, ${str}[data-checked] ${post}`,
  indeterminate: (str, post) => `${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
  readOnly: (str, post) => `${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
  expanded: (str, post) => `${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
  placeholderShown: (str, post) => `${str}:placeholder-shown ${post}`
};
var toGroup = (fn) => merge((v) => fn(v, "&"), "[role=group]", "[data-group]", ".group");
var toPeer = (fn) => merge((v) => fn(v, "~ &"), "[data-peer]", ".peer");
var merge = (fn, ...selectors) => selectors.map(fn).join(", ");
var pseudoSelectors = {
  _hover: "&:hover, &[data-hover]",
  _active: "&:active, &[data-active]",
  _focus: "&:focus, &[data-focus]",
  _highlighted: "&[data-highlighted]",
  _focusWithin: "&:focus-within",
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  _before: "&::before",
  _after: "&::after",
  _empty: "&:empty",
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  _checked: "&[aria-checked=true], &[data-checked]",
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  _valid: "&[data-valid], &[data-state=valid]",
  _loading: "&[data-loading], &[aria-busy=true]",
  _selected: "&[aria-selected=true], &[data-selected]",
  _hidden: "&[hidden], &[data-hidden]",
  _autofill: "&:-webkit-autofill",
  _even: "&:nth-of-type(even)",
  _odd: "&:nth-of-type(odd)",
  _first: "&:first-of-type",
  _firstLetter: "&::first-letter",
  _last: "&:last-of-type",
  _notFirst: "&:not(:first-of-type)",
  _notLast: "&:not(:last-of-type)",
  _visited: "&:visited",
  _activeLink: "&[aria-current=page]",
  _activeStep: "&[aria-current=step]",
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  _groupHover: toGroup(state.hover),
  _peerHover: toPeer(state.hover),
  _groupFocus: toGroup(state.focus),
  _peerFocus: toPeer(state.focus),
  _groupFocusVisible: toGroup(state.focusVisible),
  _peerFocusVisible: toPeer(state.focusVisible),
  _groupActive: toGroup(state.active),
  _peerActive: toPeer(state.active),
  _groupDisabled: toGroup(state.disabled),
  _peerDisabled: toPeer(state.disabled),
  _groupInvalid: toGroup(state.invalid),
  _peerInvalid: toPeer(state.invalid),
  _groupChecked: toGroup(state.checked),
  _peerChecked: toPeer(state.checked),
  _groupFocusWithin: toGroup(state.focusWithin),
  _peerFocusWithin: toPeer(state.focusWithin),
  _peerPlaceholderShown: toPeer(state.placeholderShown),
  _placeholder: "&::placeholder",
  _placeholderShown: "&:placeholder-shown",
  _fullScreen: "&:fullscreen",
  _selection: "&::selection",
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  _mediaDark: "@media (prefers-color-scheme: dark)",
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  _horizontal: "&[data-orientation=horizontal]",
  _vertical: "&[data-orientation=vertical]"
};
var pseudoPropNames = Object.keys(
  pseudoSelectors
);
var systemProps = (0, import_lodash3.default)(
  {},
  background,
  border,
  color,
  flexbox,
  layout,
  filter,
  ring,
  interactivity,
  grid,
  others,
  position,
  effect,
  space,
  scroll,
  typography,
  textDecoration,
  transform,
  list,
  transition
);
var layoutSystem = Object.assign({}, space, layout, flexbox, grid, position);
var layoutPropNames = Object.keys(
  layoutSystem
);
var propNames = [...Object.keys(systemProps), ...pseudoPropNames];
var styleProps = { ...systemProps, ...pseudoSelectors };
function defineStyle(styles) {
  return styles;
}
function createMultiStyleConfigHelpers(parts) {
  return {
    definePartsStyle(config) {
      return config;
    },
    defineMultiStyleConfig(config) {
      return { parts, ...config };
    }
  };
}

// src/theme/styles/disclosure/Tabs/Tabs.ts
import { mode as mode2 } from "@chakra-ui/theme-tools";
var { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(tabsAnatomy.keys);
var baseStyleTab = defineStyle((props) => ({
  borderRadius: 0,
  borderBottom: "1px solid",
  borderBottomColor: "transparent",
  textTransform: "capitalize",
  fontSize: "md",
  lineHeight: "md",
  fontFamily: "suisseIntlMedium",
  color: "neutral.400",
  _active: {
    borderBottomColor: colors_default.neutral.black
  },
  _focus: {
    borderBottomColor: `${colors_default.neutral.black} !important`,
    boxShadow: 0
  },
  _selected: {
    borderBottomColor: "neutral.black",
    color: mode2("neutral.black", "neutral.white")(props),
    sup: {
      backgroundColor: mode2("neutral.black", "neutral.white")(props),
      color: mode2("neutral.white", "neutral.black")(props)
    }
  },
  _focusVisible: {
    boxShadow: `inset 0 0 0 1px ${colors_default.neutral.white}, 0 0 0 2px ${colors_default.neutral.black}`
  },
  marginBottom: "-1px",
  sup: {
    marginLeft: "8px",
    px: 2,
    py: 0,
    backgroundColor: "neutral.400",
    borderRadius: "10px",
    color: "neutral.white",
    fontSize: "md",
    fontWeight: "bold",
    lineHeight: "1.3",
    top: 0
  }
}));
var baseStyleTabList = defineStyle({
  borderBottom: "1px solid",
  borderBottomColor: "neutral.300",
  overflowX: "auto",
  scrollbarWidth: "none",
  "::-webkit-scrollbar": {
    width: 0,
    height: 0
  }
});
var baseStyleTabpanel = defineStyle({
  padding: 0
});
var baseStyle = definePartsStyle((props) => ({
  tab: baseStyleTab(props),
  tablist: baseStyleTabList,
  tabpanel: baseStyleTabpanel
}));
var tabsTheme = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    size: "md",
    variant: "unstyled"
  }
});
var Tabs_default = tabsTheme;

// src/theme/styles/typography/Heading.ts
var Heading = {
  baseStyle: {
    fontFamily: "suisseIntlRegular",
    fontWeight: 500
  },
  sizes: {
    "6xl": {
      lineHeight: "6xl",
      fontSize: "6xl"
    },
    "6xl-static": {
      lineHeight: "6xl",
      fontSize: "6xl-static"
    },
    "5xl": {
      lineHeight: "5xl",
      fontSize: "5xl"
    },
    "5xl-static": {
      lineHeight: "5xl",
      fontSize: "5xl-static"
    },
    "4xl": {
      lineHeight: "4xl",
      fontSize: "4xl"
    },
    "4xl-static": {
      lineHeight: "4xl",
      fontSize: "4xl-static"
    },
    "3xl": {
      lineHeight: "3xl",
      fontSize: "3xl"
    },
    "3xl-static": {
      lineHeight: "3xl",
      fontSize: "3xl-static"
    },
    "2xl": {
      lineHeight: "2xl",
      fontSize: "2xl"
    },
    "2xl-static": {
      lineHeight: "2xl",
      fontSize: "2xl-static"
    },
    xl: {
      lineHeight: "xl",
      fontSize: "xl"
    },
    lg: {
      lineHeight: "lg",
      fontSize: "lg"
    },
    md: {
      lineHeight: "md",
      fontSize: "md"
    },
    sm: {
      lineHeight: "sm",
      fontSize: "sm"
    },
    xs: {
      lineHeight: "xs",
      fontSize: "xs"
    }
  },
  variants: {
    inverted: {
      bg: "neutral.black",
      color: "neutral.white",
      px: 3,
      py: 2,
      mt: 0,
      display: "inline-flex"
    },
    semibold: {
      fontWeight: 600
    },
    bold: {
      fontFamily: "suisseIntlBold"
    },
    medium: {
      fontFamily: "suisseIntlMedium"
    },
    serif: {
      fontFamily: "gesturaTextRegular",
      letterSpacing: "normal"
    }
  }
};
var Heading_default = Heading;

// src/theme/styles/typography/Text.ts
var Text = {
  baseStyle: {
    fontFamily: "suisseIntlRegular",
    lineHeight: "md",
    letterSpacing: bodyLetterSpacing
  },
  sizes: {
    xl: {
      lineHeight: "xl",
      fontSize: "xl"
    },
    lg: {
      lineHeight: "lg",
      fontSize: "lg"
    },
    md: {
      lineHeight: "md",
      fontSize: "md"
    },
    sm: {
      lineHeight: "sm",
      fontSize: "sm"
    },
    xs: {
      lineHeight: "xs",
      fontSize: "xs"
    }
  },
  variants: {
    semibold: {
      fontWeight: 600
    },
    bold: {
      fontFamily: "suisseIntlBold"
    },
    medium: {
      fontFamily: "suisseIntlMedium"
    }
  }
};
var Text_default = Text;

// src/theme/styles/layout/Divider.ts
var Divider = {
  baseStyle: {
    borderColor: "neutral.300"
  }
};
var Divider_default = Divider;

// src/theme/styles/overlays/Drawer/Drawer.ts
import { mode as mode3 } from "@chakra-ui/theme-tools";
var Drawer = {
  baseStyle: (props) => ({
    dialogContainer: {
      position: "initial"
    },
    drawerOverlay: {
      background: "rgba(0, 0, 0, 0.48)"
    },
    drawerBody: {
      p: 6
    },
    drawerHeader: {
      color: "black.500",
      bg: mode3("neutral.white", "neutral.700")(props),
      fontWeight: "normal",
      fontFamily: "suisseIntlRegular",
      borderBottom: "1px solid",
      borderBottomColor: "neutral.300",
      fontSize: "xl",
      lineHeight: "1rem",
      borderRadius: 0,
      p: 6
    },
    drawerContent: {
      bg: mode3("neutral.white", "neutral.700")(props),
      overflow: "hidden"
    },
    drawerFooter: {
      p: 4
    }
  })
};
var Drawer_default = Drawer;

// src/theme/styles/overlays/Modal/Modal.ts
import { mode as mode4 } from "@chakra-ui/theme-tools";
var { definePartsStyle: definePartsStyle2, defineMultiStyleConfig: defineMultiStyleConfig2 } = createMultiStyleConfigHelpers(modalAnatomy.keys);
var baseDialogContainer = defineStyle({
  paddingX: 3
});
var baseStyleDialog = defineStyle((props) => ({
  bg: mode4("neutral.white", "neutral.700")(props),
  borderRadius: 0,
  maxW: "400px"
}));
var baseStyleHeader = defineStyle((props) => ({
  color: mode4("neutral.black", "neutral.white")(props),
  textAlign: "center",
  fontWeight: "normal",
  fontFamily: "suisseIntlMedium",
  borderBottom: "1px solid",
  borderBottomColor: "neutral.300",
  fontSize: "xl",
  lineHeight: "1rem",
  p: 6
}));
var baseStyleCloseButton = defineStyle((props) => ({
  color: mode4("neutral.black", "neutral.white")(props),
  fontSize: "sm",
  top: 4
}));
var baseStyleBody = defineStyle({
  padding: 6
});
var baseStyleFooter = defineStyle({
  justifyContent: "center",
  py: 3,
  borderTop: "1px solid",
  borderTopColor: "neutral.300"
});
var baseStyle2 = definePartsStyle2((props) => ({
  dialogContainer: baseDialogContainer,
  dialog: baseStyleDialog(props),
  header: baseStyleHeader(props),
  closeButton: baseStyleCloseButton(props),
  body: baseStyleBody,
  footer: baseStyleFooter
}));
var sizes = {
  lg: definePartsStyle2({
    header: { padding: 7 },
    dialog: { maxW: "600px" },
    closeButton: { top: 5 },
    footer: {
      py: 4
    }
  })
};
var modalTheme = defineMultiStyleConfig2({
  baseStyle: baseStyle2,
  sizes,
  defaultProps: { size: "sm" }
});
var Modal_default = modalTheme;

// src/theme/styles/overlays/Popover/Popover.ts
import { mode as mode5 } from "@chakra-ui/theme-tools";
var Popover = {
  baseStyle: (props) => ({
    content: {
      borderRadius: "4px",
      minWidth: "220px",
      fontFamily: "suisseIntlRegular",
      fontWeight: "normal",
      bg: mode5("neutral.white", "neutral.700")(props)
    },
    // the arrow color from the popover is non-editable without the !important
    arrow: {
      bg: `${mode5(
        colors_default.neutral.white,
        colors_default.neutral[700]
      )(props)} !important`
    },
    body: {
      p: "1rem"
    }
  }),
  variants: {
    inverted: {
      arrow: {
        bg: "green.700"
      },
      content: {
        bg: "green.700",
        color: "neutral.white"
      }
    }
  }
};
var Popover_default = Popover;

// src/theme/styles/form-elements/FormControl/FormLabel/FormLabel.ts
var FormLabel = {
  baseStyle: {
    fontFamily: "suisseIntlRegular"
  }
};
var FormLabel_default = FormLabel;

// src/theme/styles/form-elements/Button/Button.ts
var shared = {
  primary: {
    _disabled: {
      bg: `${colors_default.neutral[200]} !important`,
      color: "neutral.400",
      _hover: { color: "neutral.400" }
    }
  },
  secondary: {
    bg: "transparent",
    border: "1px solid",
    borderColor: "neutral.black",
    _disabled: {
      bg: "transparent !important",
      color: `${colors_default.neutral[400]} !important`
    }
  },
  link: {
    padding: "0.375rem !important",
    height: "34px !important",
    bg: "transparent"
  }
};
var Button = {
  baseStyle: {
    fontFamily: "suisseIntlRegular",
    fontSize: "md",
    fontStyle: "normal",
    borderRadius: 0,
    px: 8,
    py: "0.625rem",
    lineHeight: 1.375,
    _active: { boxShadow: "none" },
    _focus: {
      outline: 0,
      boxShadow: "none"
    },
    _disabled: {
      bg: "neutral.200",
      border: "none",
      color: "neutral.400",
      opacity: 1
    },
    _focusVisible: {
      boxShadow: "inset 0 0 0 4px #2C7DF6",
      borderColor: "transparent"
    },
    _loading: {
      display: "inline-flex",
      textOverflow: "none"
    }
  },
  sizes: {
    lg: {
      minWidth: "auto",
      fontSize: "md",
      height: "42px",
      py: "0.625rem",
      px: "1rem"
    },
    md: {
      minWidth: "auto",
      fontSize: "sm",
      height: "32px",
      py: "0.375rem",
      px: "1rem"
    },
    sm: {
      minWidth: "auto",
      fontSize: "sm",
      height: "24px",
      py: "0.125rem",
      px: "0.5rem"
    }
  },
  variants: {
    primary: {
      ...shared.primary,
      bg: "neutral.600",
      color: "neutral.white",
      _hover: {
        color: "neutral.200",
        bg: "neutral.black"
      },
      _active: {
        color: "neutral.200",
        bg: "neutral.black"
      }
    },
    "primary-dark": {
      ...shared.primary,
      bg: "neutral.white",
      color: "neutral.600",
      _hover: {
        bg: "neutral.200"
      },
      _active: {
        bg: "neutral.200"
      }
    },
    secondary: {
      ...shared.secondary,
      color: "neutral.600",
      _hover: {
        bg: "neutral.black",
        color: "neutral.white"
      },
      _active: {
        bg: "neutral.black",
        color: "neutral.white"
      },
      _loading: {
        _hover: {
          color: "neutral.white"
        }
      },
      _disabled: {
        bg: "transparent",
        color: `${colors_default.neutral[400]} !important`,
        border: "1px solid transparent",
        boxShadow: "inset 0 0 0 1px #EDEDED"
      }
    },
    "secondary-dark": {
      ...shared.secondary,
      border: `1px solid ${colors_default.neutral.white} !important`,
      color: "neutral.white",
      _hover: {
        bg: "neutral.white",
        color: "neutral.600"
      },
      _active: {
        bg: "neutral.white",
        color: "neutral.600"
      },
      _disabled: {
        bg: "transparent",
        color: `${colors_default.neutral[400]} !important`
      }
    },
    link: (props) => ({
      ...shared.link,
      color: props.color || "neutral.600",
      textDecoration: "none",
      _hover: {
        textDecoration: "none",
        bg: "neutral.200",
        color: props.color || "neutral.600"
      },
      _active: {
        textDecoration: "none",
        bg: "neutral.200",
        color: props.color || "neutral.600"
      },
      _disabled: {
        bg: "transparent",
        color: "neutral.400",
        _hover: { color: "neutral.400" }
      }
    }),
    "link-dark": {
      ...shared.link,
      color: "neutral.white",
      textDecoration: "none",
      _hover: {
        color: "neutral.600",
        bg: "neutral.white"
      },
      _active: {
        color: "neutral.600",
        bg: "neutral.white"
      },
      _disabled: {
        bg: "transparent",
        color: "neutral.400",
        _hover: { color: "neutral.400" }
      }
    },
    "link-underline": (props) => ({
      ...shared.link,
      textDecoration: "underline",
      textUnderlinePosition: "under",
      textDecorationThickness: "2px",
      color: props.color || "neutral.600",
      _disabled: {
        bg: "transparent",
        color: "neutral.400",
        _hover: { color: "neutral.400" }
      },
      _hover: {
        color: props.color || "neutral.600"
      },
      _active: {
        color: props.color || "neutral.600"
      }
    }),
    "link-underline-dark": {
      ...shared.link,
      color: "neutral.100",
      textDecoration: "underline",
      textUnderlinePosition: "under",
      textDecorationThickness: "2px",
      _disabled: {
        bg: "transparent",
        color: "neutral.400",
        _hover: { color: "neutral.400" }
      },
      _hover: {
        color: "neutral.white"
      },
      _active: {
        color: "neutral.white"
      }
    }
  }
};
var Button_default = Button;

// src/theme/styles/form-elements/Checkbox/Checkbox.ts
import { mode as mode6 } from "@chakra-ui/theme-tools";
var { definePartsStyle: definePartsStyle3, defineMultiStyleConfig: defineMultiStyleConfig3 } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);
var sharedDisabledStyle = {
  bg: "neutral.300",
  border: "none"
};
var baseStyleControl = defineStyle((props) => ({
  border: "1px solid",
  borderRadius: 0,
  borderColor: mode6("neutral.500", "neutral.white")(props),
  bg: "neutral.white",
  _disabled: {
    ...sharedDisabledStyle
  },
  _checked: {
    color: mode6("neutral.white", "neutral.black")(props),
    bg: mode6("neutral.black", "neutral.white")(props),
    borderColor: mode6("neutral.black", "neutral.white")(props),
    _hover: {
      bg: mode6("neutral.black", "neutral.white")(props),
      borderColor: mode6("neutral.black", "neutral.white")(props)
    },
    _disabled: {
      ...sharedDisabledStyle,
      color: "neutral.500"
    }
  },
  _indeterminate: {
    color: mode6("neutral.white", "neutral.black")(props),
    bg: mode6("neutral.black", "neutral.white")(props),
    borderColor: mode6("neutral.black", "neutral.white")(props),
    _disabled: {
      ...sharedDisabledStyle
    }
  },
  _focusVisible: {
    boxShadow: "none",
    position: "relative",
    _after: {
      content: '""',
      position: "absolute",
      zIndex: "-1",
      top: "-2px",
      left: "-2px",
      right: "-2px",
      bottom: "-2px",
      border: "2px solid #2C7DF6",
      filter: "blur(2px)"
    }
  }
}));
var baseStyleLabel = defineStyle((props) => ({
  color: mode6("neutral.700", "neutral.white")(props),
  _disabled: {
    opacity: 1,
    color: mode6("neutral.400", "neutral.white")(props)
  }
}));
var baseStyle3 = definePartsStyle3((props) => ({
  control: baseStyleControl(props),
  label: baseStyleLabel(props)
}));
var sizes2 = {
  lg: definePartsStyle3({
    container: { paddingBottom: 2 },
    control: { w: 6, h: 6 },
    label: { fontSize: "md" },
    icon: { fontSize: "0.875rem" }
  }),
  md: definePartsStyle3({
    container: { paddingBottom: 2 },
    control: { w: 5, h: 5 },
    label: { fontSize: "sm" },
    icon: { fontSize: "0.875rem" }
  }),
  sm: definePartsStyle3({
    control: { w: 4, h: 4 },
    label: { fontSize: "xs" },
    icon: { fontSize: "0.625rem" }
  })
};
var checkboxTheme = defineMultiStyleConfig3({
  baseStyle: baseStyle3,
  sizes: sizes2,
  defaultProps: { size: "md" }
});
var Checkbox_default = checkboxTheme;

// src/theme/styles/form-elements/Radio/Radio.ts
import { mode as mode7 } from "@chakra-ui/theme-tools";
var { defineMultiStyleConfig: defineMultiStyleConfig4, definePartsStyle: definePartsStyle4 } = createMultiStyleConfigHelpers(radioAnatomy.keys);
var baseStyleControl2 = defineStyle((props) => ({
  border: "1px solid",
  borderColor: mode7("neutral.700", "neutral.white")(props),
  bg: "neutral.white",
  _checked: {
    border: "2px solid",
    borderColor: mode7("neutral.black", "neutral.white")(props),
    bg: mode7("neutral.white", "neutral.black")(props),
    color: mode7("neutral.black", "neutral.white")(props),
    _before: {
      bg: mode7("neutral.black", "neutral.white")(props),
      w: "80%",
      h: "80%"
    },
    _hover: {
      bg: mode7("neutral.white", "neutral.black")(props),
      borderColor: mode7("neutral.black", "neutral.white")(props),
      color: mode7("neutral.black", "neutral.white")(props)
    }
  },
  _focusVisible: {
    boxShadow: "none",
    position: "relative",
    _after: {
      content: '""',
      position: "absolute",
      zIndex: "-1",
      top: "-1px",
      left: "-1px",
      right: "-1px",
      bottom: "-1px",
      boxShadow: "0 0 0 2px #2C7DF6",
      filter: "blur(2px)",
      borderRadius: "50%"
    }
  },
  _disabled: {
    opacity: 1,
    bg: "neutral.300",
    borderColor: "neutral.300",
    color: "neutral.300",
    _hover: {
      bg: "neutral.300",
      borderColor: "neutral.300"
    }
  }
}));
var baseLabelStyle = defineStyle({
  _disabled: {
    opacity: 1,
    color: "neutral.300"
  }
});
var baseStyle4 = definePartsStyle4((props) => ({
  control: baseStyleControl2(props),
  label: baseLabelStyle
}));
var sizes3 = {
  lg: definePartsStyle4({
    container: { paddingBottom: 2 },
    control: { width: 6, height: 6 },
    label: { fontSize: "md" }
  }),
  md: definePartsStyle4({
    container: { paddingBottom: 2 },
    control: {
      w: 5,
      h: 5,
      _checked: {
        _before: {
          w: "75%",
          h: "75%"
        }
      }
    },
    label: { fontSize: "sm" }
  }),
  sm: definePartsStyle4({
    control: { width: 4, height: 4 },
    label: { fontSize: "xs" }
  })
};
var radioTheme = defineMultiStyleConfig4({
  baseStyle: baseStyle4,
  sizes: sizes3,
  defaultProps: {
    size: "md",
    colorScheme: "neutral"
  }
});
var Radio_default = radioTheme;

// src/theme/styles/form-elements/Select/Select.ts
var { defineMultiStyleConfig: defineMultiStyleConfig5, definePartsStyle: definePartsStyle5 } = createMultiStyleConfigHelpers(selectAnatomy.keys);
var baseFieldStyle = defineStyle({
  lineHeight: 1.375,
  borderRadius: 0,
  _disabled: {
    color: "neutral.400"
  }
});
var baseIconStyle = defineStyle({
  color: "neutral.500"
});
var baseStyle5 = definePartsStyle5({
  field: baseFieldStyle,
  icon: baseIconStyle
});
var variants = {
  primary: definePartsStyle5({
    field: {
      color: "neutral.white",
      bg: "neutral.black",
      borderRadius: 0,
      _disabled: {
        bg: "neutral.200",
        // applying _focusVisible doesn't work on the icon property, so we need to leverage this sibling operator
        " + .chakra-select__icon-wrapper": {
          color: "neutral.400"
        }
      }
    },
    icon: {
      color: "neutral.white"
    }
  }),
  secondary: definePartsStyle5({
    _focusVisible: {
      bg: "neutral.white",
      color: "neutral.black"
    },
    field: {
      borderColor: "neutral.white",
      borderRadius: 0,
      _focusVisible: {
        bg: "neutral.white",
        color: "neutral.black",
        " + .chakra-select__icon-wrapper": {
          color: "neutral.black"
        }
      },
      _disabled: {
        borderColor: "neutral.200"
      }
    }
  })
};
var selectTheme = defineMultiStyleConfig5({
  baseStyle: baseStyle5,
  variants
});
var Select_default = selectTheme;

// src/theme/styles/form-elements/shared/field.ts
var fieldDefaults = {
  borderRadius: "3px",
  borderColor: "neutral.400",
  fontSize: "lg",
  height: "3rem",
  border: "1px solid"
};
var fieldHover = {
  borderColor: "neutral.500"
};
var fieldFocus = {
  borderColor: "neutral.black",
  boxShadow: "0px 0px 0px 3px rgba(0, 0, 0, 0.1)"
};
var fieldDisabled = {
  bg: "neutral.200"
};

// src/theme/styles/form-elements/Textarea/Textarea.ts
var Textarea = {
  baseStyle: {},
  variants: {
    outline: {
      ...fieldDefaults,
      _hover: {
        ...fieldHover
      },
      _focus: {
        ...fieldFocus
      },
      _disabled: {
        ...fieldDisabled
      }
    }
  },
  defaultProps: {
    size: "lg"
  }
};
var Textarea_default = Textarea;

// src/theme/styles/form-elements/Input/Input.ts
var { definePartsStyle: definePartsStyle6, defineMultiStyleConfig: defineMultiStyleConfig6 } = createMultiStyleConfigHelpers(inputAnatomy.keys);
var variants2 = {
  outline: definePartsStyle6({
    field: {
      ...fieldDefaults,
      _hover: {
        ...fieldHover
      },
      _focus: {
        ...fieldFocus
      },
      _disabled: {
        ...fieldDisabled
      }
    },
    addon: {
      borderRadius: "3px",
      fontSize: "lg",
      height: "3rem",
      px: 4,
      bg: "neutral.300"
    }
  }),
  filled: definePartsStyle6({
    field: {
      ...fieldDefaults,
      borderColor: "green.700",
      bg: "beige.100",
      _hover: {
        borderColor: "green.700",
        bg: "beige.100"
      },
      _focus: {
        borderColor: "green.700",
        bg: "beige.100"
      }
    },
    addon: {}
  })
};
var inputTheme = defineMultiStyleConfig6({
  variants: variants2
});
var Input_default = inputTheme;

// src/theme/styles/form-elements/Switch/Switch.ts
var { defineMultiStyleConfig: defineMultiStyleConfig7, definePartsStyle: definePartsStyle7 } = createMultiStyleConfigHelpers(switchAnatomy.keys);
var baseTrackStyles = defineStyle({
  background: "neutral.300",
  _checked: {
    background: "green.700"
  },
  _disabled: {
    background: "neutral.200",
    opacity: 1,
    // the disabled property does not get applied to the thumb element
    ".chakra-switch__thumb": {
      background: "neutral.300"
    }
  }
});
var baseThumbStyles = defineStyle({
  background: "neutral.white"
});
var baseStyle6 = definePartsStyle7({
  track: baseTrackStyles,
  thumb: baseThumbStyles
});
var switchTheme = defineMultiStyleConfig7({
  baseStyle: baseStyle6
});
var Switch_default = switchTheme;

// src/theme/styles/data-display/Tag/Tag.ts
var { defineMultiStyleConfig: defineMultiStyleConfig8, definePartsStyle: definePartsStyle8 } = createMultiStyleConfigHelpers(tagAnatomy.keys);
var sharedContainerStyles = {
  bg: "beige.100",
  color: "neutral.black",
  minH: "22px",
  fontSize: "xs",
  fontFamily: "suisseIntlRegular",
  fontWeight: "normal",
  borderRadius: 0,
  py: "2px",
  px: 1
};
var baseStyleContainer = defineStyle({
  ...sharedContainerStyles,
  marginBottom: 1,
  marginRight: 1,
  marginTop: 1
});
var baseStyle7 = definePartsStyle8({
  container: baseStyleContainer
});
var sizes4 = {
  sm: definePartsStyle8({
    container: sharedContainerStyles
  }),
  md: definePartsStyle8({
    container: {
      ...sharedContainerStyles,
      py: "8px",
      px: "10px",
      svg: {
        width: 5,
        height: 5
      }
    },
    label: {
      fontSize: "sm",
      lineHeight: "20px"
    }
  })
};
var variants3 = {
  medium: definePartsStyle8({
    container: {
      ...sharedContainerStyles,
      fontFamily: "suisseIntlMedium"
    }
  })
};
var tagTheme = defineMultiStyleConfig8({
  baseStyle: baseStyle7,
  sizes: sizes4,
  variants: variants3,
  //
  // https://github.com/chakra-ui/chakra-ui/issues/4581
  defaultProps: {
    variant: "none",
    size: "sm"
  }
});
var Tag_default = tagTheme;

// src/theme/styles/data-display/List/List.ts
var { definePartsStyle: definePartsStyle9, defineMultiStyleConfig: defineMultiStyleConfig9 } = createMultiStyleConfigHelpers(listAnatomy.keys);
var baseStyleContainer2 = defineStyle({
  fontFamily: "suisseIntlRegular",
  lineHeight: "1.5rem",
  letterSpacing: bodyLetterSpacing
});
var baseStyle8 = definePartsStyle9({
  container: baseStyleContainer2
});
var listTheme = defineMultiStyleConfig9({
  baseStyle: baseStyle8
});
var List_default = listTheme;

// src/theme/styles/data-display/Stat/Stat.ts
var { defineMultiStyleConfig: defineMultiStyleConfig10, definePartsStyle: definePartsStyle10 } = createMultiStyleConfigHelpers(statAnatomy.keys);
var sizes5 = {
  lg: definePartsStyle10({
    container: {
      fontSize: "lg"
    },
    number: {
      size: "2xl",
      fontSize: "2xl"
    }
  })
};
var variantPrimary = definePartsStyle10({
  container: {
    fontFamily: "suisseIntlRegular",
    bg: "neutral.white"
  },
  label: {
    color: "neutral.400"
  },
  number: {
    fontWeight: 600
  }
});
var variantSecondary = definePartsStyle10({
  container: {
    bg: "neutral.black",
    color: "neutral.white"
  },
  label: {
    color: "neutral.white"
  }
});
var variants4 = {
  primary: variantPrimary,
  secondary: variantSecondary
};
var statTheme = defineMultiStyleConfig10({
  sizes: sizes5,
  variants: variants4
});
var Stat_default = statTheme;

// src/theme/styles/feedback/Alert/Alert.ts
import { mode as mode8 } from "@chakra-ui/theme-tools";
var { definePartsStyle: definePartsStyle11, defineMultiStyleConfig: defineMultiStyleConfig11 } = createMultiStyleConfigHelpers(alertAnatomy.keys);
var baseStyleContainer3 = defineStyle({
  px: 4,
  py: "1.125rem",
  fontSize: "sm",
  fontFamily: "suisseIntlMedium",
  color: "neutral.black"
});
var baseIconStyle2 = defineStyle({
  marginLeft: 1
});
var baseStyle9 = definePartsStyle11({
  container: baseStyleContainer3,
  icon: baseIconStyle2
});
var variantSuccess = definePartsStyle11((props) => ({
  container: {
    bg: mode8("green.500", "green.200")(props),
    color: mode8("neutral.white", "neutral.black")(props)
  },
  icon: {
    color: mode8("green.100", "green.500")(props)
  }
}));
var variantSuccessLight = definePartsStyle11((props) => ({
  container: {
    bg: mode8("green.100", "green.800")(props),
    color: mode8("neutral.black", "neutral.white")(props)
  },
  icon: {
    color: mode8("green.500", "green.100")(props)
  }
}));
var variantWarning = definePartsStyle11((props) => ({
  container: {
    bg: mode8("yellow.500", "yellow.300")(props)
  }
}));
var variantWarningLight = definePartsStyle11((props) => ({
  container: {
    bg: mode8("yellow.100", "yellow.800")(props),
    color: mode8("neutral.black", "neutral.white")(props)
  },
  icon: {
    color: mode8("yellow.500", "yellow.100")(props)
  }
}));
var variantError = definePartsStyle11((props) => ({
  container: {
    bg: mode8("red.700", "red.200")(props),
    color: mode8("neutral.white", "neutral.black")(props)
  }
}));
var variantErrorLight = definePartsStyle11((props) => ({
  container: {
    bg: mode8("red.100", "red.800")(props),
    color: mode8("neutral.black", "neutral.white")(props)
  },
  icon: {
    color: mode8("red.700", "red.100")(props)
  }
}));
var variants5 = {
  success: variantSuccess,
  "success-light": variantSuccessLight,
  warning: variantWarning,
  "warning-light": variantWarningLight,
  error: variantError,
  "error-light": variantErrorLight
};
var alertTheme = defineMultiStyleConfig11({
  baseStyle: baseStyle9,
  variants: variants5
});
var Alert_default = alertTheme;

// src/theme/styles/feedback/Progress/Progress.ts
var { defineMultiStyleConfig: defineMultiStyleConfig12, definePartsStyle: definePartsStyle12 } = createMultiStyleConfigHelpers(progressAnatomy.keys);
var baseStyleTrack = defineStyle({
  bg: "neutral.200",
  borderRadius: "10px"
});
var baseStyleFilledTrack = defineStyle((props) => ({
  bg: props?.color ?? "green.700",
  borderRadius: "10px"
}));
var baseStyle10 = definePartsStyle12((props) => ({
  track: baseStyleTrack,
  filledTrack: baseStyleFilledTrack(props)
}));
var progressTheme = defineMultiStyleConfig12({
  baseStyle: baseStyle10,
  defaultProps: {
    size: "lg"
  }
});
var Progress_default = progressTheme;

// src/theme/styles/layout/Link/Link.ts
var shared2 = {
  link: {
    fontFamily: "suisseIntlRegular",
    fontWeight: 600,
    px: 8,
    py: "0.625rem",
    lineHeight: 1.375,
    padding: "0.375rem !important",
    height: "34px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    _active: { boxShadow: "none" },
    _focus: {
      outline: 0,
      boxShadow: "none"
    },
    _disabled: {
      bg: "neutral.200",
      border: "none",
      color: "neutral.400",
      opacity: 1
    }
  }
};
var Link = {
  baseStyle: {
    textDecoration: "underline",
    textUnderlinePosition: "under",
    color: "green.700",
    _hover: {
      textDecoration: "none"
    }
  },
  sizes: {
    lg: {
      fontSize: "md",
      height: "34px"
    },
    sm: {
      fontSize: "sm",
      height: "24px"
    }
  },
  variants: {
    link: {
      ...shared2.link,
      color: "neutral.600",
      textDecoration: "none",
      _hover: {
        textDecoration: "none",
        bg: "neutral.200",
        color: "neutral.black"
      },
      _active: {
        textDecoration: "none",
        bg: "neutral.200",
        color: "neutral.600"
      },
      _disabled: {
        bg: "transparent",
        color: "neutral.400",
        _hover: { color: "neutral.400" }
      }
    },
    "link-dark": {
      ...shared2.link,
      color: "neutral.white",
      _hover: {
        color: "neutral.600",
        bg: "neutral.white",
        textDecoration: "none"
      },
      _active: {
        color: "neutral.600",
        bg: "neutral.white"
      },
      _disabled: {
        bg: "transparent",
        color: "neutral.400",
        _hover: { color: "neutral.400" }
      }
    },
    "link-underline": {
      ...shared2.link,
      textDecoration: "underline",
      textUnderlinePosition: "under",
      textDecorationThickness: "2px",
      color: "neutral.600",
      _disabled: {
        bg: "transparent",
        color: "neutral.400",
        _hover: { color: "neutral.400" }
      },
      _hover: {
        color: "neutral.black",
        textDecoration: "underline",
        textUnderlinePosition: "under",
        textDecorationThickness: "2px"
      },
      _active: {
        color: "neutral.black"
      }
    },
    "link-underline-dark": {
      ...shared2.link,
      color: "neutral.100",
      textDecoration: "underline",
      textUnderlinePosition: "under",
      textDecorationThickness: "2px",
      _disabled: {
        bg: "transparent",
        color: "neutral.400",
        _hover: { color: "neutral.400" }
      },
      _hover: {
        color: "neutral.white",
        textDecoration: "underline",
        textUnderlinePosition: "under",
        textDecorationThickness: "2px"
      },
      _active: {
        color: "neutral.white"
      }
    }
  }
};
var Link_default = Link;

// src/theme/styles/data-display/Table/Table.ts
var { defineMultiStyleConfig: defineMultiStyleConfig13, definePartsStyle: definePartsStyle13 } = createMultiStyleConfigHelpers(tableAnatomy.keys);
var sharedThStyles = {
  color: "neutral.700",
  textTransform: "none",
  fontWeight: "normal",
  fontFamily: "suisseIntlMedium",
  letterSpacing: "normal"
};
var sharedCaptionStyles = {
  color: "neutral.700"
};
var baseStyle11 = definePartsStyle13({
  thead: {
    th: {
      ...sharedThStyles
    }
  },
  tfoot: {
    th: {
      ...sharedThStyles
    }
  }
});
var variantSimple = definePartsStyle13({
  thead: {
    th: {
      ...sharedThStyles,
      borderTop: "1px solid",
      borderTopColor: "neutral.200",
      borderBottom: "2px solid",
      borderBottomColor: "neutral.200"
    }
  },
  tbody: {
    "th, td": {
      borderBottomColor: "neutral.200"
    }
  },
  caption: {
    ...sharedCaptionStyles
  },
  tfoot: {
    th: {
      borderTop: "2px solid",
      borderTopColor: "neutral.200",
      ...sharedThStyles
    }
  }
});
var variantStriped = definePartsStyle13({
  thead: {
    th: {
      ...sharedThStyles,
      borderBottom: "2px solid",
      borderBottomColor: "neutral.400"
    }
  },
  tbody: {
    tr: {
      "&:nth-of-type(odd)": {
        "th, td": {
          border: 0
        },
        td: {
          background: "neutral.200"
        }
      },
      td: {
        border: 0
      }
    }
  },
  tfoot: {
    th: {
      borderTop: "2px solid",
      borderTopColor: "neutral.400",
      ...sharedThStyles
    }
  },
  caption: {
    ...sharedCaptionStyles
  }
});
var variants6 = {
  simple: variantSimple,
  striped: variantStriped
};
var sizes6 = {
  sm: definePartsStyle13({
    thead: {
      th: {
        fontSize: "sm"
      }
    },
    tfoot: {
      th: {
        fontSize: "sm"
      }
    }
  }),
  md: definePartsStyle13({
    thead: {
      th: {
        fontSize: "md"
      }
    },
    tfoot: {
      th: {
        fontSize: "md"
      }
    }
  })
};
var tableTheme = defineMultiStyleConfig13({
  baseStyle: baseStyle11,
  variants: variants6,
  sizes: sizes6
});
var Table_default = tableTheme;

// src/theme/index.ts
var theme = {
  config: {
    initialColorMode: "light",
    useSystemColorMode: false
  },
  styles: {
    global: (props) => ({
      "html, body": {
        fontSize: "100%",
        height: "100%",
        minHeight: "100%",
        "#auraErrorMessage": {
          display: "none"
        }
      },
      body: {
        bg: mode9("neutral.white", "neutral.800")(props),
        color: mode9("neutral.700", "neutral.white")(props)
      },
      // typography
      ...fontFaceDeclarations,
      "strong, b": {
        fontFamily: `${fontFaceProps.suisseIntlBold} !important`
        // this gets overridden on <Text as="strong" /> unless we use an !important
      }
    })
  },
  fonts: {
    ...fontFaceProps
  },
  colors: colors_default,
  // Component style overrides
  // https://chakra-ui.com/docs/theming/customize-theme#customizing-component-styles
  components: {
    Breadcrumb: Breadcrumb_default,
    Divider: Divider_default,
    Drawer: Drawer_default,
    Heading: Heading_default,
    Tabs: Tabs_default,
    Text: Text_default,
    Modal: Modal_default,
    Input: Input_default,
    Radio: Radio_default,
    Select: Select_default,
    Textarea: Textarea_default,
    FormLabel: FormLabel_default,
    Button: Button_default,
    Checkbox: Checkbox_default,
    Popover: Popover_default,
    Switch: Switch_default,
    Tag: Tag_default,
    List: List_default,
    Stat: Stat_default,
    Alert: Alert_default,
    Progress: Progress_default,
    Link: Link_default,
    Table: Table_default
  },
  fontSizes,
  lineHeights
};
var globalTheme = extendTheme(theme);
var theme_default = globalTheme;

export {
  theme_default
};
